import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import DoctorOPDAssessmentList from "./OPD/Doctor/DoctorOPDAssessmentList";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from 'sweetalert2';
import { selectHasPermission } from "../store/slices/authSlice";
import { fetchDoctorOPDAssessments, deleteDoctorOPDAssessment } from "../store/slices/doctorOPDAssessmentsSlice";

const DoctorOPDAssessments = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { doctorOPDAssessments, isLoading } = useSelector((state) => state.doctorOPDAssessments);

    // Mock Permission
    const canManageDoctorOPD = useSelector((state) =>
        selectHasPermission(state, "doctor-opd-assessment-manage")
    );
    const canCreateDoctorOPD = useSelector((state) =>
        selectHasPermission(state, "doctor-opd-assessment-create")
    );
    const canEditDoctorOPD = useSelector((state) =>
        selectHasPermission(state, "doctor-opd-assessment-edit")
    );
    const canDeleteDoctorOPD = useSelector((state) =>
        selectHasPermission(state, "doctor-opd-assessment-delete")
    );

    useEffect(() => {
        if (canManageDoctorOPD) {
            dispatch(fetchDoctorOPDAssessments());
        }
    }, [dispatch, canManageDoctorOPD]);

    if (!canManageDoctorOPD) {
        return (
            <Navigate to="/dashboard" state={{ error: "No permission to manage Doctor OPD Assessments." }} replace />
        );
    }

    const handleAdd = () => navigate("/doctor-opd-assessments/add");
    const handleEdit = (id) => navigate(`/doctor-opd-assessments/edit/${id}`);

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to delete this Doctor Assessment?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            customClass: {
                confirmButton: 'btn btn-primary me-3',
                cancelButton: 'btn btn-label-secondary'
            },
            buttonsStyling: false
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteDoctorOPDAssessment(id)).unwrap();
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'Doctor Assessment has been deleted.',
                    customClass: { confirmButton: 'btn btn-success' }
                });
            } catch (err) {
                console.error("Failed to delete assessment:", err);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: err || 'Failed to delete assessment.',
                    customClass: { confirmButton: 'btn btn-danger' }
                });
            }
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        {isLoading ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <DoctorOPDAssessmentList
                                assessments={doctorOPDAssessments}
                                onEdit={canEditDoctorOPD ? handleEdit : null}
                                onDelete={canDeleteDoctorOPD ? handleDelete : null}
                                onAddAssessment={canCreateDoctorOPD ? handleAdd : null}
                            />
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default DoctorOPDAssessments;
